import { render, staticRenderFns } from "./MainContentSearchable.vue?vue&type=template&id=35536027"
import script from "./MainContentSearchable.vue?vue&type=script&lang=js"
export * from "./MainContentSearchable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports